// 投资者关系
<template>
  <div>
    <Logo></Logo>
    <!-- <Header/> -->
    <div><img :src="image" class="bg"></div>
    <InvestorBar></InvestorBar>
    <Tabbar class="tabbar"></Tabbar>
    
  </div>
</template>

<script>
import InvestorBar from '../Investor/Investor_components/InvestorBar.vue'
import Tabbar from '../Index/Index_components/Tabbar.vue'
// import Header from '../../common/FirstHeader.vue'
import api from '@/utils/api'
import Logo from "../Index/Index_components/logo.vue"
export default {
  name: 'Investor',
  components: {
    InvestorBar,
    Tabbar,
    // Header,
    Logo,
  },
  data () {
    return {
      image: '',
    }
  },
  created () {
      
    this.getImage()
  },
  methods: {
    async getImage () {
      const { data: data } = await api.getInvestorImage()
      console.log(data)
      this.image = data.data.image
      window.localStorage.setItem('investor', JSON.stringify({
        time: new Date().getTime(),
        data: data
      }))
    }
  },
}
</script>

<style scoped>
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 15rem;
}
</style>
